import { DescriptionIcon } from "@l2r-front/l2r-icons"
import { API_MODULE_CAMPAIGN, APP_CAMPAIGN, I18N_NAMESPACE, MODULE_CAMPAIGNS } from "@l2r-front/l2r-shared-campaign"

import { L2rAppCampaign } from "../app"

export const appCampaign = {
    index: 100,
    color: "primary",
    component: <L2rAppCampaign />,
    externalContexts: [],
    i18nNamespace: I18N_NAMESPACE,
    modules: {
        campaigns: {
            index: 0,
            id: API_MODULE_CAMPAIGN,
            icon: DescriptionIcon,
            label: "app.modules.campaigns",
            path: MODULE_CAMPAIGNS,
        },
    },
    path: APP_CAMPAIGN,
}